import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Chart, ChartModule } from 'angular-highcharts';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'stats-pie-chart',
  styleUrls: ['./stats-pie-chart.scss'],
  standalone: true,
  imports: [
    ChartModule
  ],
  templateUrl: './stats-pie-chart.component.html'
})
export class StatsPieChartComponent implements OnChanges {
    @Input() public options: any = {};
    public chart: Chart = new Chart();

    private readonly baseOptions: any;

    constructor(translator: TranslateService) {
        this.baseOptions = {
            chart: {
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false,
                type: 'pie'
            },
            title: {
                text: ''
            },
            tooltip: {
                pointFormat: '<b>{point.percentage:.1f} %</b>'
            },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: true,
                        format: '<b>{point.name}</b>: {point.percentage:.1f} %'
                    }
                }
            },
            colors: [
                '#C29D4D',
                '#83964E',
                '#4D885E',
                '#23746A',
                '#205E69',
                '#2F4858',
                '#000000',
                '#6DB58B',
                '#3CB7C7',
                '#99DEFF',
                '#4062D5',
                '#9142DB',
            ],
            credits: {
                enabled: false
            },
            lang: {
                noData: translator.instant('NoData')
            }
        };
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes['options']) {
            this.chart = new Chart({ ...this.baseOptions, series: this.options.series ?? [] });
        }
    }
}
